// 路由器
import React, { useState }  from 'react';
import { Menu } from 'antd';
import IPConfigPage from './IPConfigPage';
import { ServerPageDecoration } from './ServerPageDecoration';

export const Router = (props) => {
    const { node, device } = props;
    const [menuData, setMenuData] = useState('LAN')

    return (
        <ServerPageDecoration paddingTop={0}>
            <Menu onClick={(e) => setMenuData(e.key)} selectedKeys={[menuData]} defaultSelectedKeys={['WAN']} mode="horizontal" style={{background: '#ECF3FA',}}>
                <Menu.Item key="LAN" style={{
                    width: '92px',
                    height: '45px',
                    background: '#C2D1E8',
                    borderRadius: '36px',
                    textAlign: 'center',
                    }}>
                    LAN配置
                </Menu.Item>
                <Menu.Item key="WAN" style={{
                    width: '92px',
                    height: '45px',
                    background: '#C2D1E8',
                    borderRadius: '36px',
                    textAlign: 'center',
                    marginTop: '10px'
                    }}>
                    WAN配置
                </Menu.Item>

            </Menu>
            <hr style={{width: '600px',height: '2px',background: '#D5DDE5',}}></hr>
            { menuData === 'LAN' ? (<IPConfigPage mode="router" node={node} device={ device.getLan() } onSubmit={device.onConfigChange} />) : null }
            { menuData === 'WAN' ? (<IPConfigPage node={node} device={ device.getWan() } onSubmit={device.onConfigChange} />) : null }
        </ServerPageDecoration>
    )
}